import React from 'react';
import './select.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { IColor, IInput, ILabel } from 'utils/types/contentful';
import clsx from 'clsx';

const returnNativeSelectVariant = (
  type: string,
  color: IColor,
  label: ILabel
): string => {
  const selectColor = color && color.classname;
  const focus = `focus:ring-${selectColor} focus:border-${selectColor}`;
  switch (type) {
    case 'contained':
      return `bg-${selectColor} ${focus} text-${label?.color?.classname}`;
    case 'outlined':
      return `border border-${selectColor} ${focus} text-${label?.color?.classname}`;
    case 'white':
      return `bg-white border border-black ${focus}`;
    case 'standard':
      return 'bg-white';
    default:
      return `bg-white border border-black ${focus}`;
  }
};

const returnNativeSelectSize = (size: string): string => {
  switch (size) {
    case 'base':
      return 'pl-3 pr-10 py-2';
    case 'lg':
      return 'pl-3 pr-10 py-2';
    default:
      return 'pl-3 pr-10 py-2';
  }
};

export interface NativeSelectProps extends IInput {
  onChange: Function;
  button: Element;
  color: IColor;
}

export const NativeSelect: React.FC<NativeSelectProps> = ({
  label,
  type,
  name,
  color,
  values,
  size,
  onChange,
  register,
  selectedValue,
}) => (
  <div className='w-full'>
    {label && (
      <Label
        {...label}
        htmlFor={name}
        transform='capitalize'
      />
    )}
    <select
      id='location'
      name='location'
      onChange={onChange}
      style={{ backgroundColor: type === 'outlined' && 'transparent' }}
      className={clsx(
        returnNativeSelectSize(size),
        returnNativeSelectVariant(type, color, label),
        'block w-full focus:outline-none rounded-md'
      )}
      {...(register && register(name))}>
      {values &&
        values.map((value) => (
          <option
            value={value.value}
            selected={value.value === selectedValue && true}>
            {value.label?.text}
          </option>
        ))}
    </select>
  </div>
);
